import { render } from "./ZoomYTransition.vue?vue&type=template&id=6ddca9dd"
import script from "./ZoomYTransition.vue?vue&type=script&lang=js"
export * from "./ZoomYTransition.vue?vue&type=script&lang=js"

import "./ZoomYTransition.vue?vue&type=style&index=0&id=6ddca9dd&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__